import get from 'lodash/get';
import { createAction } from 'redux-act';
import { selectNotifications } from '../selectors';
const timeouts = new Map();
export const createNotification = createAction('Create notification');
export const closeNotification = createAction('Close notification', id => {
  clearTimeout(timeouts.get(id));
  timeouts.delete(id);
  return id;
});
export const closeAllNotifications = createAction('Close all notifications', args => {
  for (const id of timeouts.values()) {
    clearTimeout(id);
  }
  timeouts.clear();
  return args;
});

/**
 * Compare strings to "guess"
 * if a notification with the same message is already displayed.
 */
const isSameMessage = (notification, allNotifications) => {
  let found = false;
  if (typeof notification.message === 'string') {
    found = allNotifications.filter(notif => notif.message === notification.message).length > 0;
  }
  if (typeof notification.message === 'object') {
    const searchedString = get(notification, 'message.__html', '');
    found = allNotifications.map(notif => {
      if (notif.message === 'string') {
        return notif.message;
      }
      return get(notif, 'message.__html');
    }).filter(Boolean).filter(stringMessage => stringMessage === searchedString).length > 0;
  }
  return found;
};
export function clearNotificationTimeout(notification) {
  const prevTimeout = timeouts.get(notification.id);
  if (prevTimeout) {
    clearTimeout(prevTimeout);
    timeouts.delete(notification.id);
  }
}
export function setNotificationTimeout(notification, dispatch) {
  const timeoutId = setTimeout(() => {
    dispatch(closeNotification(notification.id));
  }, notification.timeout);
  timeouts.set(notification.id, timeoutId);
}

/**
 * Proxy the dispatch of create/close notification to handle
 * timeout delays for self-closing.
 */
export const createNotificationProxy = notification => (dispatch, getState) => {
  // before creating a notification, check that the message is not already there.
  const state = getState();
  const allNotifications = selectNotifications(state);
  if (isSameMessage(notification, allNotifications)) {
    return;
  }

  // Discard notification automatically after timeout ms.
  if (typeof notification.timeout === 'number' && notification.dismissible) {
    clearNotificationTimeout(notification);
    setNotificationTimeout(notification, dispatch);
  }
  dispatch(createNotification(notification));
};